/**
 * The withdraw / off-ramp flow: approve → handleTokenBurn → createOrder.
 *
 * This is the flow that stranded PKR 4,000 in the router escrow. The burn
 * verifier below is the piece that makes it self-healing: the router already
 * records the escrow as `getWithdrawAmount(user).depositLocked`, so after any
 * interruption we can ask the chain directly whether the burn happened —
 * no transaction hash needed.
 */

import { registerFlow } from "../flows";
import { approveSatisfied, tupleField } from "../verifiers";
import { CONTRACTS } from "../../utils/contractAddresses";
import RouterAbi from "../../abi/IFrdmRouterCombined.json";

export const WITHDRAW_FLOW = "withdraw";
export const WITHDRAW_STEPS = { APPROVE: "approve", BURN: "burn" };

/**
 * `getWithdrawAmount(user)` returns `{ currency, amount, depositLocked }`.
 * `depositLocked === true` means the user's tokens are sitting in the router
 * escrow — i.e. `handleTokenBurn` has already run.
 */
export async function burnSatisfied({ client, entry }) {
  const result = await client.readContract({
    address: CONTRACTS.frdmRouter,
    abi: RouterAbi,
    functionName: "getWithdrawAmount",
    args: [entry.address],
  });
  return tupleField(result, "depositLocked", 2) === true;
}

registerFlow({
  id: WITHDRAW_FLOW,
  steps: {
    [WITHDRAW_STEPS.APPROVE]: { verifyOnChain: approveSatisfied },
    [WITHDRAW_STEPS.BURN]: { verifyOnChain: burnSatisfied },
  },
});
